import { c as e } from "react/compiler-runtime";
import "react";
import { jsx as t } from "react/jsx-runtime";
import n from "@jetbrains/ring-ui-built/components/link/link.js";
//#region src/components/ExternalLink/ExternalLink.tsx
var r = {
	target: "_blank",
	rel: "noopener noreferrer"
}, i = (i) => {
	let a = e(2), o;
	return a[0] === i ? o = a[1] : (o = /* @__PURE__ */ t(n, {
		title: "Open external resource",
		...i,
		...r
	}), a[0] = i, a[1] = o), o;
};
//#endregion
export { r as EXTERNAL_LINK_PARAMETERS, i as ExternalLink };
